<template>
    <section class="product-details">
        <master-loader :is-loaded="uiStates.showLoading"></master-loader>
        <div class="row">
            <div class="col-md-8">
                <div class="product-heading-container clearfix">
                    <div class="product-details-thumbnail  bg-pos-center" v-if="generalDetails.thumbnail" :style="{ backgroundImage: 'url(' + generalDetails.thumbnail + ')' }"></div>
                    <div class="product-heading">
                        <h1> {{product.info.name}} </h1>
                        <div class="id-container">ID: {{product.info.id}}</div>
                        <div class="id-container" v-if="product.info.sku">SKU: {{product.info.sku}}</div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="product-timestamps">
                    <div class="timestamp">
                        <strong>Created:</strong> {{this.formatDate(product.info.dateAdded)}}
                    </div>
                    <div class="timestamp">
                        <strong>Updated:</strong> {{this.formatDate(product.info.dateUpdated)}}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-9">
                <product-alerts :status="alert" v-model="alert"></product-alerts>
                <div class="product-form-container">
                    <div class="placard">
                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item dropdown">
                                <a :class="{ 'active': isGeneralRouteActive }" class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">General</a>
                                <div class="dropdown-menu">
                                    <router-link
                                    class="dropdown-item"
                                    active-class="active"
                                    exact
                                    :to="{name: 'details'}"
                                    >Details</router-link>
                                    <router-link
                                    v-if="featureAllowed('seo')"
                                    class="dropdown-item"
                                    active-class="active"
                                    exact
                                    :to="{name: 'seo'}"
                                    >SEO</router-link>
                                    <router-link
                                    v-if="featureAllowed('marketing')"
                                    class="dropdown-item"
                                    active-class="active"
                                    exact
                                    :to="{name: 'marketing'}"
                                    >Marketing</router-link>
                                    <router-link
                                    v-if="featureAllowed('shipping')"
                                    class="dropdown-item"
                                    active-class="active"
                                    exact
                                    :to="{name: 'shipping'}"
                                    >Shipping</router-link>
                                    <router-link
                                    v-if="featureAllowed('barcodes')"
                                    class="dropdown-item"
                                    active-class="active"
                                    exact
                                    :to="{name: 'barcodes'}"
                                    >Barcodes</router-link>
                                    <router-link
                                    class="dropdown-item"
                                    active-class="active"
                                    exact
                                    :to="{name: 'tags'}"
                                    >Tags</router-link>
                                </div>
                            </li>
                            <li class="nav-item">
                                <router-link
                                class="nav-link"
                                active-class="active"
                                exact
                                :to="{name: 'categories'}"
                                >
                                Categories
                                </router-link>
                            </li>
                            <li class="nav-item dropdown"  v-if="navigationDisplayGroups.length > 0">
                                <a :class="{ 'active': this.$route.name === 'attributes' }" class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">Attributes</a>
                                <div class="dropdown-menu">
                                    <router-link
                                        class="dropdown-item"
                                        active-class="active"
                                        exact
                                        :to="{name: 'attributes', params: { displayGroupId: null, panelName: 'Attributes' }}"
                                        >Default
                                    </router-link>
                                    <div v-for="displayGroup in navigationDisplayGroups">
                                        <router-link
                                        v-if="displayGroup.generic_attributes_count > 0"
                                        class="dropdown-item"
                                        active-class="active3"
                                        exact
                                        :to="{name: 'attributes', params: { displayGroupId: displayGroup.id, panelName: displayGroup.name }}"
                                        >{{displayGroup.name}}</router-link>
                                        <div class="dropdown-divider"></div>
                                    </div>
                                </div>
                            </li>
                            <li class="nav-item" v-else>
                                <router-link
                                    class="nav-link"
                                    active-class="active"
                                    exact
                                    :to="{name: 'attributes', params: { displayGroupId: null, panelName: 'Attributes' }}"
                                    >Attributes
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link
                                class="nav-link"
                                active-class="active"
                                exact
                                v-if="featureAllowed('assets')"
                                :to="{name: 'assets'}"
                                >
                                Assets
                                </router-link>
                            </li>

                            <li class="nav-item dropdown">
                                <a :class="{ 'active': isPricingRouteActive }" class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">Pricing</a>
                                <div class="dropdown-menu">
                                    <router-link
                                    class="dropdown-item"
                                    active-class="active"
                                    exact
                                    :to="{name: 'pricing-active'}"
                                    >Active Price Records</router-link>
                                    <router-link
                                    class="dropdown-item"
                                    active-class="active"
                                    exact
                                    :to="{name: 'pricing-future'}"
                                    >Future Price Records</router-link>
                                    <router-link
                                    class="dropdown-item"
                                    active-class="active"
                                    exact
                                    :to="{name: 'pricing-expired'}"
                                    >Expired Price Records</router-link>
                                </div>
                            </li>
                            <li class="nav-item">
                                <router-link
                                class="nav-link"
                                active-class="active"
                                exact
                                v-if="featureAllowed('price_profiles') && permissionAllowed('price_profile_view')"
                                :to="{name: 'pricing-profiles'}"
                                >
                                Pricing Profiles
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link
                                class="nav-link"
                                active-class="active"
                                exact
                                v-if="featureAllowed('inventory') && permissionAllowed('view_inventory')"
                                :to="{name: 'inventory'}"
                                >
                                Inventory
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link
                                class="nav-link"
                                active-class="active"
                                exact
                                v-if="featureAllowed('exclusions')"
                                :to="{name: 'exclusions'}"
                                >
                                Exclusions
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="isBundle">
                                <router-link
                                class="nav-link"
                                active-class="active"
                                exact
                                v-if="featureAllowed('product_bundles')"
                                :to="{name: 'bundle-products'}"
                                >
                                Bundles
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link
                                class="nav-link"
                                active-class="active"
                                exact
                                v-if="featureAllowed('product_children') && isAValidParent"
                                :to="{name: 'child-products'}"
                                >
                                Children
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link
                                class="nav-link"
                                active-class="active"
                                exact
                                v-if="featureAllowed('product_relations')"
                                :to="{name: 'relations'}"
                                >
                                Relations
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link
                                class="nav-link"
                                active-class="active"
                                id="channels-tab"
                                exact
                                v-if="featureAllowed('channels')"
                                :to="{name: 'channels'}"
                                >
                                Channels
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link
                                class="nav-link"
                                active-class="active"
                                exact
                                v-if="featureAllowed('activity')"
                                :to="{name: 'activity'}"
                                >
                                Activity
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link
                                class="nav-link"
                                active-class="active"
                                exact
                                v-if="featureAllowed('scheduled_content')&& permissionAllowed('view_products')"
                                :to="{name: 'scheduled-content'}"
                                >
                                Scheduled Content
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link
                                class="nav-link"
                                active-class="active"
                                exact
                                :to="{name: 'projects'}"
                                >
                                Projects
                                </router-link>
                            </li>
                        </ul>
                        <div class="tab-content" id="myTabContent">
                            <router-view
                            @get-categories="handleFetchAllCategories"
                            :general-details="generalDetails"
                            :product-details="product"
                            v-model="generalDetails"
                            ref="ProductGeneral"
                            ></router-view>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <product-sidebar :product-details="product" :workflow-steps="workflowSteps" v-model="productData"></product-sidebar>
            </div>
        </div>
    </section>
</template>

<script type="text/javascript">
var base_url = window.location.protocol + "//" + window.location.host;
var url_pathArray = window.location.pathname.split("/");

import Vue from "vue";
import VueEvents from "vue-events";
import axios from "axios";

import ProductAlerts from "./product-details-alerts.vue";
import ProductSidebar from "./product-details-sidebar.vue";
import ProductWorkflow from "./product-details-workflow.vue";
import ProductGeneral from "./product-details-general.vue";
import ProductPricing from "./product-details-pricing-v2.vue";
import ProductSeo from "./product-details-seo.vue";
import ProductMarketing from "./product-details-marketing.vue";
import ProductShipping from "./product-details-shipping.vue";
import ProductAttributes from "./product-details-attributes.vue";
import ProductActivity from "./product-details-activity.vue";
import ProductBundles from "./product-details-bundles.vue";
import ProductChildren from "./product-details-children.vue";
import ProductAssets from "./product-details-assets.vue";
import ProductTableTest from "./product-details-table-test.vue";
import ProductScheduledContent from "./product-details-scheduled-content.vue";
import ProductProjects from "./product-details-projects.vue";
import MasterLoader from "./product-master-loader.vue";
import select2 from "select2";
import moment from 'moment-timezone';

import router from "../../router";

Vue.use(VueEvents);

export default {
    name: "product-details",
    router,
    props: [],
    components: {
        MasterLoader,
        "product-alerts": ProductAlerts,
        "product-sidebar": ProductSidebar,
        "product-workflow": ProductWorkflow,
        "product-general": ProductGeneral,
        "product-pricing": ProductPricing,
        "product-seo": ProductSeo,
        "product-marketing": ProductMarketing,
        "product-shipping": ProductShipping,
        "product-attributes": ProductAttributes,
        "product-activity": ProductActivity,
        "product-bundles": ProductBundles,
        "product-children": ProductChildren,
        "product-table-test": ProductTableTest,
        "product-scheduled-content": ProductScheduledContent,
        "product-details-projects": ProductProjects
    },
    data() {
        return {
            isBundle: null,
            alert: {
                message: "",
                status: "alert-success",
                timeOut: 15000
            },
            categoriesList: [],
            assignedCategories: [],
            loadedStates: {
                categories: false,
                attribute_sets: false,
                attributes: false,
                option_set: false,
                tags: false,
                details: false
            },
            uiStates: {
                showLoading: true,
                showWorkflowLoading: true,
                activePanel: "details"
            },
            navigationDisplayGroups: dataObject.navigationDisplayGroups,
            languages: {
                listing: dataObject.languages,
                active: 0
            },
            product: {
                info: dataObject.productDetails,
                readiness: {
                    content_status: false,
                    categorization_status: false,
                    photo_status: false,
                    pricing_status: false,
                    stock_status: false
                },
                permissions: {
                    delete_products: true
                },
                features: {}
            },
            loadedPanelData: {
                seo: false,
                shipping: false,
                marketing: false,
                attributes: false,
                children: false,
                assets: false
            },
            hasChildren: dataObject.hasChildren,
            productOptionData: {},
            childOptionData: {},
            productSeo: null,
            productShipping: null,
            productShippingLanguage: null,
            productAssets: null,
            productMarketing: {},
            productDetails: {},
            productAttributes: {},
            filteredDisplayGroupId: {},
            productChildren: {},
            workflowSteps: [
                {
                    label: "Default",
                    status: "completed"
                },
                {
                    label: "New",
                    status: "completed"
                },
                {
                    label: "In Progress",
                    status: "active"
                },
                {
                    label: "Pending Approval",
                    status: ""
                },
                {
                    label: "Approved",
                    status: ""
                }
            ],
            generalDetails: {},
            productPricing: [],
            clientTimezone: null
        };
    },
    mounted() {
        this.loadProductDetails();
        this.isProductABundle();
        this.getClientTimezone();
    },
    beforeCreate() {},
    watch: {
        loadedStates: {
            handler: function() {
                let obj_length = Object.keys(this.loadedStates).length;
                let count = 0;
                for (var prop in this.loadedStates) {
                    if (this.loadedStates.hasOwnProperty(prop)) {
                        if (this.loadedStates[prop]) {
                            count++;
                        }
                    }
                }
                if (count >= obj_length) {
                    this.uiStates.showLoading = false;
                    this.uiStates.showWorkflowLoading = false;
                }
            },
            deep: true
        },
        "languages.active": "checkLangChange"
    },
    methods: {
        handleFetchAllCategories() {
            //check if category list has already been loaded...
            if (this.loadedStates.categories) {
                this.$refs.ProductGeneral.updatedCategories(
                    this.categoriesList,
                    this.assignedCategories
                );
                return;
            }
            this.fetchAssignedCategoriesForProduct();
        },
        fetchAssignedCategoriesForProduct() {
            axios
                .get(
                    base_url +
                        "/pimapi/products/" +
                        this.product.info.id +
                        "/categories"
                )
                .then(response => {
                    this.loadedStates.categories = true;
                    this.assignedCategories = response.data;
                    this.$refs.ProductGeneral.updatedCategories(
                        this.categoriesList,
                        this.assignedCategories
                    );
                })
                .catch(error => {
                    this.uiStates.showLoading = false;
                    this.uiStates.errorMessage = "An error has occured!";
                });
        },
        openModal: function() {
            this.modalShow = !this.modalShow;
        },
        permissionAllowed(str) {
            if (
                this.generalDetails.permissions === null ||
                this.generalDetails.permissions === undefined ||
                this.generalDetails.permissions.length == 0
            ) {
                return;
            }
            return this.generalDetails.permissions.includes(str);
        },
        featureAllowed(str) {
            if (
                this.generalDetails.features === null ||
                this.generalDetails.features === undefined ||
                this.generalDetails.features.length == 0
            ) {
                return;
            }
            return this.generalDetails.features.includes(str);
        },
        checkLangChange() {
            if (this.$route.name === "details") {
                this.$refs.ProductGeneral.uiStates.showLoading = true;
                this.generalDetails.items = [];
                this.loadProductDetails();
            }
        },
        isProductABundle() {
            window.dataObject.productDetails.isBundle
                ? (this.isBundle = 1)
                : (this.isBundle = 0);
        },
        setPanel: function(panel) {
            this.uiStates.activePanel = panel;
        },
        loadProductDetails: function() {
            axios
                .get(
                    base_url +
                        "/pimapi/products/" +
                        this.product.info.id +
                        "/details/" +
                        this.languages.active,
                    {
                        // 'criteria': criteria,
                    }
                )
                .then(
                    function(response) {
                        this.generalDetails =
                            response.data.payload.generalDetails;
                        this.product.readiness =
                            response.data.payload.generalDetails.readiness;
                        this.loadedStates.details = true;
                        this.$refs.ProductGeneral.uiStates.showLoading = false;
                        this.uiStates.showLoading = false;
                    }.bind(this)
                )
                .catch(
                    function(error) {
                        this.uiStates.showLoading = false;
                        this.uiStates.errorMessage = "An error has occured!";
                    }.bind(this)
                );
        },
        formatDate(value) {
            if (value === null) {
                return "Never";
            }
            if (this.clientTimezone) {
                return moment.utc(value).tz(this.clientTimezone).format('MMM Do YYYY h:mm a');
            } else{
                return moment(value)
                    .utc()
                    .format("MMM Do YYYY, h:mm a");
            }

        },
        getClientTimezone: function() {
            axios
                .get(
                    base_url +
                    "/client-timezone/",
                    {
                        // 'criteria': criteria,
                    }
                )
                .then(
                    function(response) {
                        if(response.data.clientTimezone){
                            this.clientTimezone = response.data.clientTimezone
                        }
                    }.bind(this)
                )
                .catch(
                );
        }
    },
    computed: {
        productData() {
            if (this.$route.name === "details") {
                return "generalDetails";
            }
            if (this.$route.name === "seo") {
                return "product";
            }
            if (this.$route.name === "shipping") {
                return "product";
            }
            if (this.$route.name === "activities") {
                return "generalDetails";
            }
        },
        isAValidParent() {
            return this.product.info.option_set_id !== null &&
                this.product.info.parentProduct.id === null
                ? 1
                : 0;
        },
        isPricingRouteActive() {
            return (
                this.$route.name === "pricing-expired" ||
                this.$route.name === "pricing-future" ||
                this.$route.name === "pricing-expired"
            );
        },
        isGeneralRouteActive() {
            return (
                this.$route.name === "details" ||
                this.$route.name === "seo" ||
                this.$route.name === "marketing" ||
                this.$route.name === "shipping" ||
                this.$route.name === "barcodes"
            );
        }
    }
};

router.replace("/");
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}

.dropdown-item.active {
    background-color: #f2f4f7;
}
.dropdown .dropdown-menu {
    margin: -1px 0;
}
</style>
<style lang="scss">
.messaging {
    color: #566670;
    position: absolute;
    bottom: 2px;
    right: 5px;
    font-size: 9px;
}

.modal-modern {
}

.slider-modal {
    transition: all linear 0.3s;
    padding-top: 65px;
    padding-left: 0px;
    padding-right: 0px;
    position: fixed;
    right: 0px;
    top: 60px;
    bottom: 0px;
    width: 1px;
    background-color: #fff;
    box-shadow: -1px 0px 5px 0px rgba(0, 0, 0, 0.2);
    opacity: 0;
    z-index: 13;
    overflow-y: auto;
    &.open {
        transition: all linear 0.3s;
        width: 450px;
        opacity: 1;
    }
    &.is-loading {
        overflow-y: hidden;
    }
    .slider-modal-copy {
        padding-bottom: 30px;
        padding: 0px 15px 30px 15px;
        min-width: 390px;
        max-width: 100%;
        position: relative;
    }
    .vue-details-loader.alt {
        padding-top: 95px;
        position: fixed;
        width: 448px;
        left: auto;
    }

    &.slider-sml {
        &.open {
            width: 450px;
        }
        .slider-modal-copy {
            min-width: 390px;
        }
        .vue-details-loader.alt {
            width: 448px;
        }
    }
    &.slider-med {
        &.open {
            width: 650px;
        }
        .slider-modal-copy {
            min-width: 590px;
        }
        .vue-details-loader.alt {
            width: 648px;
        }
    }
    &.slider-lrg {
        &.open {
            width: 850px;
        }
        .slider-modal-copy {
            min-width: 790px;
        }
        .vue-details-loader.alt {
            width: 848px;
        }
    }
    &.slider-full {
        &.open {
            width: calc(100% - 200px);
            @media (max-width: 1300px) {
                width: calc(100% - 71px);
            }
        }
        .slider-modal-copy {
            min-width: 790px;
        }
        .vue-details-loader.alt {
            width: calc(100% - 202px);
            @media (max-width: 1300px) {
                width: calc(100% - 73px);
            }
        }
    }
}
.close-section {
    position: absolute;
    font-size: 30px;
    top: 22px;
    right: 5px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
